<!-- 财务收款 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="refresh" :showRefresh="true" :buttonFlag="false"></v-button>

            <div class="page_content_top_line">

                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item label="开始时间">
                        <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
                        <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日"
                            value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
                        <el-date-picker class="form_codition" size="mini" @change="changeTime" v-model="getRequestData.end"
                            format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="单号">
                        <label slot="label" :style="$common.labelStyle('单号')" v-html="'单号'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.woamId" size="mini" :maxlength="$store.state.inputLength">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="业务员">
                        <label slot="label" :style="$common.labelStyle('业务员')" v-html="'业务员'"></label>
                        <el-input class="form_codition" v-model.trim="getRequestData.opmName" size="mini" :maxlength="$store.state.inputLength">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="货主" prop="coName">
                        <label slot="label" :style="$common.labelStyle('货主')" v-html="'货主'"></label>
                        <el-input class="form_codition" clearable v-model="getRequestData.coName"
                            @keyup.enter.native="openSearch('4414428383875072', 0, 'coName', 'coName,coId')">
                            <el-button @click="openSearch('4414428383875072', 0, 'coName', 'coName,coId')" slot="append"
                                icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="">
            <div class="dis">
                <div class="num">
                    <div class="money">
                        <span>记录数：</span>

                        <span class="ttred">{{ totalSelLength }}</span>
                    </div>
                    <div class="money">
                        <el-popover placement="top-start" width="200" trigger="hover" content="已选择单据含税金额总和">
                            <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                        </el-popover>
                        <span>含税金额：</span>
                        <span class="ttred">{{ totalPsMoney }}</span>
                    </div>
                    <div class="money">
                        <el-popover placement="top-start" width="100" trigger="hover" content="含税金额 × 4%">
                            <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                        </el-popover>
                        <span>手续费：</span>
                        <span class="ttred">{{ serviceCharge }}</span>
                    </div>
                    <div class="money">
                        <el-popover placement="top-start" width="400" trigger="hover"
                            content="余额 = 购进发票金额 + 补票金额 - 出库金额 - 含税金额">
                            <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                        </el-popover>
                        <span>余额：</span>
                        <span class="ttred">{{ $common.getDecimalInfo(3, (balance - totalPsMoney)) }}</span>
                        <!-- <span class="ttred">{{$common.toFixed2((balance-totalPsMoney),2)}}</span> -->
                    </div>
                    <div class="money" style="display:flex;align-items:center">
                        <span>税率：</span>
                        <el-select v-model="taxrate" placeholder="请选择">
                            <el-option v-for="item in taxrateList" :key="item.diValue" :label="item.diName"
                                :value="item.diValue">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="money">
                        <el-popover placement="top-start" width="100" trigger="hover" content="余额×税率">
                            <i slot="reference" class="el-icon-question" style="font-size: 16px" />
                        </el-popover>
                        <span>税额：</span>
                        <span class="ttred">{{
                            $common.getDecimalInfo(3, ((balance - totalPsMoney) * (Number(taxrate) / 100))) }}</span>
                        <!-- <span class="ttred">{{$common.toFixed2(((balance-totalPsMoney)*(Number(taxrate)/100)),2)}}</span> -->
                    </div>
                </div>
            </div>
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="原始单据" name="first">
                    <div class="page_content_center">
                        <el-table stripe ref="newTable" :data="returnData.list" @select-all="selectAll1" @select="select1"
                            @selection-change="handleSelectionChange" height="90%" border style="width: 100%"
                            highlight-current-row size="mini">
                            <el-table-column type="selection" width="40">
                            </el-table-column>
                            <el-table-column v-for="(tableValye, tableKey) in rawField" :key="tableKey" show-overflow-tooltip
                                :prop="tableValye.field" :label="tableValye.label">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.field == 'createTime'">
                                        <span v-if="scope.row[tableValye.field]">
                                            {{ $common.getLocalTime(scope.row[tableValye.field]) }}
                                        </span>
                                    </span>
                                    <span v-else-if="tableValye.field == 'woamId'">
                                        <a @click="toDetail(scope.row.woamId)">{{ scope.row.woamId }}</a>
                                    </span>
                                    <span v-else>{{ scope.row[tableValye.field] }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column fixed="right" label="操作">
                                <template slot-scope="scope">
                                    <el-link type="danger" :underline="false" @click="delOrder(scope.row)">删除</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="page_content_bottom">
                            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                                :current-page="getRequestData.page" :page-sizes="[30, 50, 100, 500]" :page-size="30"
                                layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已选单据" name="second">
                    <div class="page_content_center">
                        <el-table stripe :data="oldSelData" @select-all="selectAll2" @select="select2" ref="oldTable"
                            @selection-change="handleSelectionChange1" height="100%" border style="width: 100%"
                            highlight-current-row size="mini">
                            <el-table-column type="selection" width="40">
                            </el-table-column>
                            <el-table-column v-for="(tableValye, tableKey) in rawField" :key="tableKey" show-overflow-tooltip
                                :prop="tableValye.field" :label="tableValye.label">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.field == 'createTime'">
                                        <span v-if="scope.row[tableValye.field]">
                                            {{ $common.getLocalTime(scope.row[tableValye.field]) }}
                                        </span>
                                    </span>
                                    <span v-else-if="tableValye.field == 'woamId'">
                                        <a @click="toDetail(scope.row.woamId)">{{ scope.row.woamId }}</a>
                                    </span>
                                    <span v-else>{{ scope.row[tableValye.field] }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {

            getRequestData: { // 查询条件
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000, // 开始时间
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1, // 结束时间
                coName: '',
                coId: '',
                opmName: '',
                opmId: '',
                woamId: '',
                page: 1,
                rows: 30,
            },
            buttonList: [], //权限按钮集合
            activeName: 'first', // tab选择项
            rawData: [], // 原始数据列表
            selectData: [], // 已选数据
            totalPsMoney: 0.00, // 总含税金额
            totalSelLength: 0, // 总数
            oldSelData: [],
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            taxrate: 13,
            taxrateList: [], //税率
            taxamount: 0, //税额
            balance: 0,
            serviceCharge: 0,
            // 原始数据字段
            rawField: [{
                label: '单据编号',
                field: 'woamId'
            },
            {
                label: '日期',
                field: 'createTime'
            },
            {
                label: '业务员',
                field: 'opmName'
            },
            {
                label: '货主',
                field: 'coName'
            },
            {
                label: '单位名称',
                field: 'cmName'
            },
            {
                label: '含税金额',
                field: 'totalMoney'
            },
            {
                label: '部门名称',
                field: 'depName'
            },
            {
                label: '操作员',
                field: 'opmName'
            },
            ],
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            parentSearchData: {}
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "oldSelData": {
            handler: function (newValue, oldValue) {
                this.totalPsMoney = 0
                newValue.forEach(item => {
                    this.totalPsMoney = this.$common.getDecimalInfo(
                        3,
                        NP.plus(this.totalPsMoney, item.totalMoney)
                    );
                })
                this.serviceCharge = this.$common.getDecimalInfo(3, (this.totalPsMoney * 0.04))
                // this.serviceCharge = this.$common.toFixed2((this.totalPsMoney * 0.04),2)
                this.totalSelLength = newValue.length
                if (newValue.length == 0) {
                    this.balance = 0
                    this.taxamount = 0
                }
                this.queryCoInvoice(newValue[0].coId)
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 删除数据
        delOrder(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [row.woamId]
                }
                let responseData = await this.$http.deleteByState(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.oldSelData.forEach((item, i) => {
                        if (item.woamId == row.woamId) this.oldSelData.splice(i, 1)
                    })
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }).catch(() => { });

        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, field) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = field;
            this.seType = type
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        // 查询余额
        async queryCoInvoice(coId) {
            let params = {
                ids: [coId]
            }
            let responseData = await this.$http.queryCoInvoice(params)
            if (responseData.status == 200) {
                this.balance = Number(responseData.result)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        // 刷新
        refresh() {
            this.activeName = 'first'
            this.getDataList()
            this.selectData = []
            this.oldSelData = []
        },
        selectAll1(selection) {
            console.log(selection)
            if (selection.length > 0) {
                if (!this.checkAll()) {
                    this.returnData.list.forEach(row => {
                        this.$refs.newTable.toggleRowSelection(row, false);
                    })
                }
                this.selectData = selection
                if (this.selectData.length >= this.oldSelData.length) {
                    if (this.oldSelData.length > 0) {
                        this.selectData.forEach(item => {
                            this.oldSelData.forEach(key => {
                                if (item.woamId != key.woamId) {
                                    this.oldSelData.push(item)
                                }
                            })
                        })
                    } else {
                        this.oldSelData = JSON.parse(JSON.stringify(this.selectData))
                    }
                } else {
                    this.oldSelData.forEach(key => {
                        this.selectData.forEach(item => {
                            if (item.woamId != key.woamId) {
                                this.oldSelData.push(item)
                            }
                        })
                    })
                }
            } else if (selection.length == 0) {
                this.selectData = []
                if (this.returnData.list.length >= this.oldSelData.length) {
                    this.returnData.list.forEach(item => {
                        this.oldSelData.forEach((key, ki) => {
                            if (item.woamId == key.woamId) {
                                this.oldSelData.splice(ki, 1)
                            }
                        })
                    })
                } else {
                    this.oldSelData.forEach((key, ki) => {
                        this.returnData.list.forEach(item => {
                            if (item.woamId == key.woamId) {
                                this.oldSelData.splice(ki, 1)
                            }
                        })
                    })
                }
            }
            this.initCheckBox()
        },
        selectAll2(selection) {
            if (selection.length == 0) {
                if (this.oldSelData.length >= this.returnData.list.length) {
                    this.oldSelData.forEach(item => {
                        this.returnData.list.forEach(key => {
                            if (item.woamId == key.woamId) {
                                this.$refs.newTable.toggleRowSelection(key, false);
                            }
                        })
                    })
                } else {
                    this.returnData.list.forEach(key => {
                        this.oldSelData.forEach(item => {
                            if (item.woamId == key.woamId) {
                                this.$refs.newTable.toggleRowSelection(key, false);
                            }
                        })
                    })
                }
                this.$nextTick(() => {
                    this.oldSelData = []
                    this.$message({
                        message: '已取消全部选择单据',
                        type: "success",
                    });
                })
            }
        },
        select1(selection, row) {
            let selected = selection.length && selection.indexOf(row) !== -1
            if (selected) {
                if (this.oldSelData.length > 0) {
                    if (this.checkIsCo(row)) {
                        this.oldSelData.push(row)
                    }
                } else {
                    this.oldSelData.push(row)
                }
            } else {
                this.oldSelData.forEach((key, ki) => {
                    if (key.woamId == row.woamId) {
                        this.oldSelData.splice(ki, 1)
                    }
                })
            }
            this.initCheckBox()
        },
        select2(selection, row) {
            let selected = selection.length && selection.indexOf(row) !== -1
            let newRow = JSON.parse(JSON.stringify(row))
            if (!selected) {
                this.oldSelData.forEach((item, index) => {
                    if (row.woamId == item.woamId) {
                        this.oldSelData.splice(index, 1)
                        this.$message({
                            message: '已取消选择该单据',
                            type: "success",
                        });
                    }
                })
                this.returnData.list.forEach(key => {
                    if (key.woamId == newRow.woamId) {
                        this.$refs.newTable.toggleRowSelection(key, false);
                    }
                })
            }
        },
        // 检查全部
        checkAll() {
            let flag = true
            for (let index = 0; index < this.selectData.length; index++) {
                const element = this.selectData[index]
                if (element.coId != this.selectData[0].coId) {
                    flag = false
                    break
                }
            }
            if (!flag) {
                this.$message({
                    message: '货主须保持一致',
                    type: "warning",
                });
            }
            return flag
        },
        // 检查单个
        checkIsCo(row) {
            if (row.coId != this.oldSelData[0].coId) {
                this.$refs.newTable.toggleRowSelection(row, false);
                this.$message({
                    message: '货主须保持一致',
                    type: "warning",
                });
                return false
            }
            return true
        },
        // 改变多选
        handleSelectionChange(val) {
            this.selectData = val
            this.totalSelLength = this.selectData.length
        },
        initCheckBox() {
            this.oldSelData.forEach((key, index) => {
                this.$nextTick(() => {
                    this.$refs.oldTable.toggleRowSelection(this.oldSelData[index], true)
                })
            })
        },
        handleSelectionChange1(val) {
            console.log(val)
        },
        // 时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.confirmCollection()
                    break;
            }
        },
        initReList() {
            if (this.returnData.list.length >= this.oldSelData.length) {
                this.returnData.list.forEach(item => {
                    this.oldSelData.forEach(key => {
                        if (item.woamId == key.woamId) {
                            this.$refs.newTable.toggleRowSelection(item, true);
                        }
                    })
                })
            } else {
                this.oldSelData.forEach(key => {
                    this.returnData.list.forEach(item => {
                        if (item.woamId == key.woamId) {
                            this.$refs.newTable.toggleRowSelection(item, true);
                        }
                    })
                })
            }
        },
        // 确认收款
        async confirmCollection() {
            if (this.oldSelData.length == 0) {
                return this.$message({
                    message: '请选择收款单据',
                    type: "warning",
                });
            }
            this.$confirm('确定已完成对已选单据的收款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.confirm()
            }).catch(() => { });
        },
        async confirm() {
            let ids = []
            this.oldSelData.forEach(item => {
                ids.push(item.woamId)
            })
            let params = {
                ids
            }
            let responseData = await this.$http.invoiceAudit(params)
            if (responseData.status == 200) {
                this.refresh()
                this.$message({
                    message: '收款成功',
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取数据列表
        async getDataList() {
            let params = JSON.parse(JSON.stringify(this.getRequestData))
            let responseData = await this.$http.queryFinancialCollect(params)
            if (responseData.status == 200) {
                let resData = JSON.parse(JSON.stringify(responseData))
                this.returnData.list = resData.result.list
                this.returnData.pages = resData.result.pages
                this.returnData.total = resData.result.total
                this.returnData.pageNum = resData.result.pageNum
                this.$nextTick(() => {
                    this.initReList()
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取税率
        async getCateDictionariesDatas1() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [47],
            });
            if (responseData.status == 200) {
                this.taxrateList = responseData.result;
                // this.taxrate = this.taxrateList[0].diValue
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取权限按钮
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getButtonList()
        this.getDataList()
        this.getCateDictionariesDatas1()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.dis {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.page_content_center {
    height: 73vh;
}

.dissp {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.num {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #606266;
    margin-right: 5%;
}

.money {
    margin-left: 50px;
}

.ttred {
    color: red;
}

.el-select {
    width: 84px;
}
</style>